// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_81i","cls2":"LoggedInDiscoveryPage-cls2_-is LoggedInDiscoveryPage-cls1_81i"};